export class ClinicalFormsConstants {
  public static readonly defaultFormId = "20ffb9af-a051-4787-a5d5-7e339bebffdf";
  public static readonly PsychosocialFormId = "dabf56ee-9552-4fed-bd75-7eeb9ddabe05";
  public static readonly assessmentType = "assessment";
  public static readonly careNoteType = "care-note";

  public static readonly appointmentCareNote = "Appointment";

  public static readonly draftStatus = "draft";
  public static readonly discardedStatus = "discarded";
  public static readonly submittedStatus = "submitted";
  public static readonly incompleteStatus = "incomplete";

  // Discard / Unable To Complete reasons (stored in the member form `reason` column)
  public static readonly noLongerNeededReason = "No Longer Needed";
  public static readonly otherReasonLabel = "Other";
  public static readonly unableToCompleteReasons = [
    "Cognitive Reason",
    "Hearing Impairment",
    "Life Event - Administer Next Month",
    "Patient Declined",
    "Recent AECOPD",
    "Recent ED and/or Hospitalization",
    "Time Constraints",
    "Other",
  ];
  public static readonly dueSoonStatus = "due soon";
  public static readonly overdueStatus = "overdue";
  public static readonly dueTodayStatus = "due today";

  public static readonly singleChoiceQuestion = "single-choice";
  public static readonly multipleChoiceQuestion = "multiple-choice";

  public static readonly topPrioritizedBanner = "top-banner-prioritized";

  public static readonly generalHealthEvalId = "52c4889d-f629-4180-b6d0-1f1de33fa781";

  public static readonly patientEnrollmentCareNote = "Enrollment Note";

  public static isReadOnly(status?: string): boolean {
    if (!status) {
      return true;
    }
    return status === ClinicalFormsConstants.submittedStatus || status === ClinicalFormsConstants.discardedStatus;
  }
}
